export default "__VITE_ASSET__DGGNn_GB__"